
import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// Register service worker for PWA offline support + install prompt
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // New version deployed — could show a toast here
    console.log('[BVB] Update available. Refresh to get the latest version.');
  },
  onSuccess: () => {
    console.log('[BVB] App is now available offline.');
  },
});